
    <div [class]="'modal-dialog' + (size ? ' modal-' + size : '') + (centered ? ' modal-dialog-centered' : '')" role="document">
        <div class="modal-content"><ng-content></ng-content></div>
    </div>
    


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.d.ts.NgbModalWindow.html